import React from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  IconButton,
} from '@applift/factor'
import { Copy } from '@applift/icons'
import unescape from 'lodash/unescape'
import formatter from 'js-beautify'

import { copyText } from '../../../../utils'
import { CreativeInfo } from '../../../../models/Creative'
import {
  HTML_CREATIVE_ID,
  VIDEO_CREATIVE_ID,
  NATIVE_CREATIVE_ID,
  AUDIO_CREATIVE_ID,
} from '../../../../constants/creative'

interface Props {
  creativeDetails: CreativeInfo | null
  isOpen: boolean
  setIsOpen: (open: boolean) => void
}

export const CreativeCodeBlock = (props: Props) => {
  const { creativeDetails, isOpen, setIsOpen } = props

  const titleText = React.useMemo(() => {
    switch (creativeDetails?.creativeTypeId) {
      case HTML_CREATIVE_ID:
        return 'HTML Code'
      case VIDEO_CREATIVE_ID:
        return 'VAST Code'
      case NATIVE_CREATIVE_ID:
        return 'VAST Code'
      case AUDIO_CREATIVE_ID:
        return 'DAAST Code'
      default:
        return 'Source Code'
    }
  }, [creativeDetails])

  const codeText = React.useMemo(
    () =>
      formatter.html_beautify(unescape(creativeDetails?.creativeSource || '')),
    [creativeDetails]
  )

  const title = (
    <Box sx={{ display: 'flex', justifyContent: 'between', width: 100 }}>
      <Typography weight="demi"> {titleText}</Typography>
      {isOpen && (
        <IconButton
          onClick={() =>
            copyText(
              unescape(creativeDetails?.creativeSource || ''),
              'Code copied successfully!'
            )
          }
        >
          <Copy fontSize={20} sx={{ textColor: 'neutral-500' }} />
        </IconButton>
      )}
    </Box>
  )

  return (
    <Accordion
      sx={{
        boxShadow: 200,
        mt: 0,
        height: 100,
        overflow: 'auto',
      }}
      onChange={() => setIsOpen(!isOpen)}
      expanded={isOpen}
    >
      <AccordionSummary
        aria-controls="creativeCode-content"
        id="creativeCode-contentField"
        sx={{ width: 100, position: 'sticky', bgColor: 'neutral-0', top: 0 }}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails sx={{ p: 16, width: 100, overflow: 'auto' }}>
        <Box Component="pre" sx={{ overflow: 'auto' }}>
          {codeText}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}
